import TumengBARCode from './src/index.vue'

TumengBARCode.install = function(Vue) {
  Vue.component(TumengBARCode.name, TumengBARCode)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(TumengBARCode)
}

export default TumengBARCode
